module.exports = __webpack_public_path__ + "media/images/subscription-promo-mobile-fd89cc3062e9e9fceb32978cc309b1a0.png";